/* eslint-disable aloft/prefer-sound-ui-button */
import { Typography, colors } from '@aloft/toolkit-sui';

import { getSectionTitle } from './getSectionTitle.ts';
import { SectionID } from './types.ts';

type Props = {
  sectionID: SectionID;
  activeSectionID: SectionID;
  setActiveSectionID: React.Dispatch<React.SetStateAction<SectionID>>;
};

export const SectionButton = ({ sectionID, activeSectionID, setActiveSectionID }: Props) => {
  const isActive = sectionID === activeSectionID;

  return (
    <button
      onClick={() => setActiveSectionID(sectionID)}
      type="button"
      // WARNING: One-off button styles below; maybe create a new
      //  button variant if we decide to reuse this component elsewhere
      style={{
        display: 'flex',
        padding: '10px 8px',
        borderRadius: '4px',
        backgroundColor: isActive ? colors.surface3 : undefined,
      }}
    >
      <Typography variant="h3" color={isActive ? 'buttonDefault' : 'textSecondary'}>
        {getSectionTitle(sectionID)}
      </Typography>
    </button>
  );
};
